module.exports = __webpack_public_path__ + "media/project8.fc66ff85.mp4";